export default __webpack_public_path__ + "static/media/volume-high.fcd61c5a.svg";